import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { useLocation } from 'react-router-dom'
import { AddDeleteUpadate, fetchPostData } from '@/Components/hooks/Api';
import DataTable from 'react-data-table-component';
import { toastifyError, toastifySuccess } from '@/Components/Common/AlertMsg';
import { AgencyContext } from '@/Context/Agency';
import { RequiredFieldIncident } from '@/Components/Pages/Utility/Personnel/Validation';
import { Decrypt_Id_Name, isLockOrRestrictModule, tableCustomStyles } from '@/Components/Common/Utility';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { get_LocalStoreData } from '@/redux/actions/Agency';
import PropListng from '@/Components/Pages/ShowAllList/PropListng';
import { get_ScreenPermissions_Data } from '@/redux/actions/IncidentAction';
import { useNibrs } from '@/Context/NIBRS/NibrsLeftTreeContext';


const Offense = (props) => {

  const { ListData, DecPropID, DecMPropID, DecIncID, isViewEventDetails = false, isLocked, setIsLocked, propertyNibrsError = [], isNibrsOnePage = false, refetchNIBRSPropertyErrors = () => { } } = props

  const dispatch = useDispatch();
  const localStoreData = useSelector((state) => state.Agency.localStoreData);
  const effectiveScreenPermission = useSelector((state) => state.Incident.effectiveScreenPermission);
  const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';
  const { refetchNibrsLeftTreeErrors } = useNibrs();

  const useQuery = () => {
    const params = new URLSearchParams(useLocation().search);
    return {
      get: (param) => params.get(param)
    };
  };

  const propertyCrimeErrorMap = useMemo(() => {
    const map = new Map();
    const currentPropertyId = Number(DecPropID || 0);
    (propertyNibrsError || []).forEach((errorItem) => {
      const normalizedErrorCode = String(errorItem?.ErrorCode || '').trim().toUpperCase();
      if (normalizedErrorCode !== 'ERROR_077' && normalizedErrorCode !== 'ERROR_078') {
        return;
      }
      let context = errorItem?.ContextJson;
      if (typeof context === 'string') {
        try {
          context = JSON.parse(context);
        } catch (err) {
          context = null;
        }
      }
      const contextPropertyId = Number(context?.property_id || errorItem?.EntityPk || 0);

      if (!(currentPropertyId > 0 && contextPropertyId === currentPropertyId)) {
        return;
      }
      const crimeIds = Array.isArray(context?.crime_ids) ? context.crime_ids : [];
      crimeIds.forEach((id) => {
        const key = String(id);
        const message = errorItem?.MessagePlain || '';
        if (!message) return;
        if (!map.has(key)) {
          map.set(key, message);
          return;
        }
        const existing = map.get(key);
        if (!existing.includes(message)) {
          map.set(key, `${existing}\n${message}`);
        }
      });
    });
    return map;
  }, [propertyNibrsError, DecPropID]);

  const query = useQuery();
  let MstPage = query?.get('page');
  const { get_Property_Count, setChangesStatus } = useContext(AgencyContext);
  const SelectedValue = useRef();
  const [ownerData, setOwnerData] = useState();
  const [loginPinID, setLoginPinID,] = useState('');
  const [ownerIdDrp, setOwnerIdDrp] = useState([]);
  const [selectedOffenses, setSelectedOffenses] = useState([]);
  const [errorTooltip, setErrorTooltip] = useState({ visible: false, text: '', x: 0, y: 0 });

  const getAttemptGroup = (attemptComplete) => {
    const raw = String(attemptComplete || '').trim().toUpperCase();
    if (raw === 'C' || raw === 'COMPLETED') return 'C';
    if (raw === 'A' || raw === 'ATTEMPTED' || raw === 'ATTEMPT') return 'A';
    if (raw === 'U' || raw === 'UNKNOWN') return 'U';
    return raw;
  };

  const [value, setValue] = useState({
    'MasterPropertyID': '', 'PropertyID': '', 'labal': '', 'IncidentID': '', 'OffenseID': null,
    'CreatedByUserFK': '', 'IsMaster': MstPage === "MST-Property-Dash" ? true : false,
  })

  const [errors, setErrors] = useState({
    'OwnerIDError': '',
  });

  useEffect(() => {
    if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
      if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
    }
  }, []);

  useEffect(() => {
    if (localStoreData) {
      setLoginPinID(localStoreData?.PINID);
      dispatch(get_ScreenPermissions_Data("P063", localStoreData?.AgencyID, localStoreData?.PINID));
    }
  }, [localStoreData]);

  useEffect(() => {
    if (DecPropID || DecMPropID) {
      get_Data_Owner(DecPropID, DecMPropID, DecIncID);
      setValue({
        ...value,
        'IncidentID': DecIncID, 'PropertyID': DecPropID, 'CreatedByUserFK': loginPinID, 'MasterPropertyID': DecMPropID, 'labal': '', 'OffenseID': null,
      })
    }
  }, [DecPropID, DecIncID]);

  useEffect(() => {
    if (DecIncID) { get_OwnerID_Drp(DecIncID); }
  }, [DecIncID])

  // Check All Field Format is True Then Submit 
  const { OwnerIDError } = errors

  useEffect(() => {
    if (OwnerIDError === 'true') {
      Add_Owner()
    }
  }, [OwnerIDError])

  const get_Data_Owner = (propertyID, DecMPropID, mainIncidentID) => {
    const val = { 'PropertyID': propertyID, 'MasterPropertyID': DecMPropID ? DecMPropID : 0, 'IncidentID': mainIncidentID, 'OffenseID': 0, 'IsMaster': MstPage === "MST-Property-Dash" ? true : false, }
    fetchPostData('PropertyOffense/GetData_PropertyOffense', val).then((res) => {
      if (res) {
        setOwnerData(res);
        // Update selectedOffenses with current selected offense IDs
        const selectedIds = res.map(item => item.OffenseID);
        setSelectedOffenses(selectedIds);
      } else {
        setOwnerData([]);
        setSelectedOffenses([]);
      }
      get_OwnerID_Drp(mainIncidentID, res);
    });
  }

  const get_OwnerID_Drp = (mainIncidentID, ownerData) => {
    const val = { 'IncidentID': mainIncidentID, 'OffenseID': 0, }
    fetchPostData('PropertyOffense/GetDataDropDown_PropertyOffense', val).then((data) => {
      if (data) {
        setOwnerIdDrp(shortArr(ownerData, data));
      }
      else {
        setOwnerIdDrp([]);
      }
    })
  }

  const shortArr = (ownerData, data) => {
    const ids = []
    ownerData?.forEach(({ OffenseID }) => ids.push(OffenseID))
    const shortArr = data?.filter(obj1 => !ownerData?.some(obj2 => obj1.CrimeID === obj2.OffenseID));
    return shortArr
  }

  // Handle checkbox change for DataTable
  const handleCheckboxChange = (offenseId, isChecked) => {
    const isDrugProperty = String(ListData?.[0]?.PropertyType_Description || '').trim().toUpperCase() === 'DRUG';
    if (isChecked && isDrugProperty) {
      const matchingOffense = sortedAllOffenses?.find((item) => String(item?.CrimeID || item?.OffenseID) === String(offenseId));
      const offenseCode = String(matchingOffense?.NIBRSCode || matchingOffense?.FBICode || '').trim().toUpperCase();
      if (offenseCode !== '35A') {
        toastifyError('When Property Type is Drug, only offense 35A can be selected.');
        return;
      }
    }

    if (isChecked) {
      // Add to selected offenses
      setSelectedOffenses(prev => {
        if (prev.includes(offenseId)) return prev;
        return [...prev, offenseId];
      });
      // Call insert API
      const offenseItem = ownerIdDrp?.find(item => item.CrimeID === offenseId);
      if (offenseItem) {
        const val = {
          'IncidentID': DecIncID,
          'PropertyID': DecPropID,
          'CreatedByUserFK': loginPinID,
          'IsMaster': MstPage === "MST-Property-Dash" ? true : false,
          'MasterPropertyID': DecMPropID,
          'labal': offenseItem.Offense_Description,
          'OffenseID': offenseId,
        };
        AddDeleteUpadate('PropertyOffense/Insert_PropertyOffense', val).then((res) => {
          const parsedData = JSON.parse(res.data);
          refetchNIBRSPropertyErrors();
          const message = parsedData.Table[0].Message;
          refetchNibrsLeftTreeErrors();
          toastifySuccess(message);
          get_Property_Count(DecPropID, DecMPropID, MstPage === "MST-Property-Dash" ? true : false);
          get_Data_Owner(DecPropID, DecMPropID, DecIncID);
          get_OwnerID_Drp(DecIncID);
        }).catch((err) => {
          console.error("🚀 ~ Insert PropertyOffense ~ err:", err);
          // Remove from selected if insert fails
          setSelectedOffenses(prev => prev.filter(id => id !== offenseId));
        });
      }
    } else {
      // Remove from selected offenses
      setSelectedOffenses(prev => prev.filter(id => id !== offenseId));
      // Find the PropertyOffenseID from ownerData
      const offenseToDelete = ownerData?.find(item => item.OffenseID === offenseId);
      if (offenseToDelete) {
        const val = {
          'propertyOffenseID': offenseToDelete.PropertyOffenseID,
          'DeletedByUserFK': loginPinID,
        };
        AddDeleteUpadate('PropertyOffense/Delete_PropertyOffense', val).then((res) => {
          const parsedData = JSON.parse(res.data);
          const message = parsedData.Table[0].Message;
          refetchNIBRSPropertyErrors();
          refetchNibrsLeftTreeErrors();
          toastifySuccess(message);
          get_Property_Count(DecPropID, DecMPropID, MstPage === "MST-Property-Dash" ? true : false);
          get_Data_Owner(DecPropID, DecMPropID, DecIncID);
          get_OwnerID_Drp(DecIncID);
        }).catch((err) => {
          console.error("🚀 ~ Delete PropertyOffense ~ err:", err);
          // Add back to selected if delete fails
          setSelectedOffenses(prev => [...prev, offenseId]);
        });
      }
    }
  };

  const Add_Owner = () => {
    const result = ownerData?.find(item => {
      if (item.OffenseID === value.OffenseID) {
        return item.OffenseID === value.OffenseID
      } else return item.OffenseID === value.OffenseID
    });
    if (result) {
      toastifyError('Offence Already Exists');
      setErrors({
        ...errors,
        ['OwnerIDError']: '',
      })
    } else if (value.OffenseID !== '') {
      const { IncidentID, PropertyID, CreatedByUserFK, MasterPropertyID, labal, OffenseID, IsMaster } = value
      const val = {
        'IncidentID': DecIncID, 'PropertyID': DecPropID, 'CreatedByUserFK': loginPinID, 'IsMaster': IsMaster,
        'MasterPropertyID': DecMPropID, 'labal': labal, 'OffenseID': OffenseID,
      }
      AddDeleteUpadate('PropertyOffense/Insert_PropertyOffense', val).then((res) => {

        setChangesStatus(false);
        const parsedData = JSON.parse(res.data);
        const message = parsedData.Table[0].Message;
        toastifySuccess(message);
        get_Property_Count(DecPropID, DecMPropID, MstPage === "MST-Property-Dash" ? true : false);
        get_Data_Owner(DecPropID, DecMPropID, DecIncID);
        get_OwnerID_Drp(DecIncID);
        onClear();
        setErrors({ ...errors, ['OwnerIDError']: '', })
      })
    }
  }

  const onClear = () => {
    SelectedValue?.current?.clearValue();
    setValue(pre => { return { ...pre, ['OffenseID']: '', ['propertyOffenseID']: '', ['labal']: '' } });
    setErrors({});

  };

  // Combine ownerIdDrp with ownerData to show all offenses
  const allOffenses = [...(ownerIdDrp || [])];
  (ownerData || []).forEach(selectedOffense => {
    // Check if offense already exists in ownerIdDrp
    const existingIndex = allOffenses.findIndex(off => off.CrimeID === selectedOffense.OffenseID);
    if (existingIndex !== -1) {
      // Update existing item to include selected offense data
      allOffenses[existingIndex] = {
        ...allOffenses[existingIndex],
        ...selectedOffense,
        isFromSelected: true
      };
    } else {
      // Add new item from selected offenses
      allOffenses.push({
        ...selectedOffense,
        CrimeID: selectedOffense.OffenseID,
        isFromSelected: true
      });
    }
  });

  // Sort: items with isFromSelected=true at top, then alphabetically by label
  const sortedAllOffenses = allOffenses.sort((a, b) => {
    // First, prioritize items from selected (isFromSelected: true)
    if (a.isFromSelected && !b.isFromSelected) return -1;
    if (!a.isFromSelected && b.isFromSelected) return 1;

    // If both have same isFromSelected status, sort alphabetically by label
    const labelA = a.Offense_Description?.toLowerCase() || '';
    const labelB = b.Offense_Description?.toLowerCase() || '';
    return labelA.localeCompare(labelB);
  });

  const selectedAttemptGroup = useMemo(() => {
    if (!selectedOffenses?.length) return '';
    const selectedSet = new Set(selectedOffenses.map((id) => String(id)));
    const selectedRow = sortedAllOffenses.find((row) =>
      selectedSet.has(String(row?.CrimeID || row?.OffenseID))
    );
    return getAttemptGroup(selectedRow?.AttemptComplete);
  }, [selectedOffenses, sortedAllOffenses]);

  const columns = [
    {
      name: '',
      width: '60px',
      cell: (row) => {
        const offenseId = row.CrimeID || row.OffenseID;
        const isChecked = selectedOffenses.includes(offenseId);
        const rowAttemptGroup = getAttemptGroup(row?.AttemptComplete);
        const isAttemptMismatch = Boolean(selectedAttemptGroup) && selectedAttemptGroup !== rowAttemptGroup;
        const isDrugProperty = String(ListData?.[0]?.PropertyType_Description || '').trim().toUpperCase() === 'DRUG';
        const rowNibrsCode = String(row?.NIBRSCode || row?.FBICode || '').trim().toUpperCase();
        const isNibrs35A = rowNibrsCode === '35A';
        const isDrugRestricted = isDrugProperty && !isNibrs35A;
        const isLockedCheckbox = isLockOrRestrictModule("Lock", ownerData, isLocked, true);
        const disableCheckbox = isLockedCheckbox || isDrugRestricted || (!isChecked && isAttemptMismatch);
        return (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => handleCheckboxChange(offenseId, e.target.checked)}
            disabled={disableCheckbox}
            style={{ cursor: disableCheckbox ? 'not-allowed' : 'pointer' }}
          />
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Offense Code/Name',
      selector: (row) => row.Offense_Description,
      sortable: true
    },
    {
      name: 'Attempted/Completed',
      selector: (row) => row.AttemptComplete || '',
      sortable: true
    },
    {
      name: 'Error',
      selector: (row) => row.NIBRSCode ? row.NIBRSCode : '',
      sortable: true,
      cell: (row) => {
        const offenseId = row.CrimeID || row.OffenseID;
        const isChecked = selectedOffenses.includes(offenseId);
        const contextMessage = propertyCrimeErrorMap.get(String(row.CrimeID || row.OffenseID));
        const tooltipMessage = contextMessage || '';
        // Only show the error when the row is selected (checkbox checked).
        if (tooltipMessage && isChecked) {
          return (
            <span
              style={{ position: 'relative' }}
              onMouseEnter={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const centerX = rect.left + (rect.width / 2);
                const safeX = Math.min(Math.max(centerX, 280), window.innerWidth - 280);
                setErrorTooltip({
                  visible: true,
                  text: tooltipMessage,
                  x: safeX,
                  y: rect.top,
                });
              }}
              onMouseLeave={() => setErrorTooltip({ visible: false, text: '', x: 0, y: 0 })}
            >
              <span style={{ color: 'red', textDecoration: 'underline', cursor: 'pointer' }}>
                Error
              </span>
            </span>
          );
        }
      },
    },
    {
      name: 'TIBRS Code',
      selector: (row) => row.NIBRSCode ? row.NIBRSCode : '',
      sortable: true,
      cell: (row) => {
        const tibrsCode = row.NIBRSCode || '';
        return <span>{tibrsCode || row?.FBICode}</span>;
      },
    },
  ]

  const conditionalRowStyles = [
    {
      when: (row) => {
        const offenseId = row.CrimeID || row.OffenseID;
        const isChecked = selectedOffenses.includes(offenseId);
        const contextMessage = propertyCrimeErrorMap.get(String(row.CrimeID || row.OffenseID));
        return Boolean(contextMessage) && isChecked;
      },
      style: { backgroundColor: "rgb(255 202 194)" },
    },
  ];

  const propertyNibrsErrorArr = useMemo(() => {
    if (Array.isArray(propertyNibrsError)) return propertyNibrsError;
    return propertyNibrsError ? [propertyNibrsError] : [];
  }, [propertyNibrsError]);

  const shouldShowPropertyLossCodeError = useMemo(() => {
    const currentPropertyId = Number(DecPropID || 0);
    const matchingErrorCodeCount = propertyNibrsErrorArr.filter((item) => {
      const normalizedCode = String(item?.ErrorCode || '').trim().toUpperCase();
      if (!(normalizedCode === 'ERROR_077' || normalizedCode === 'ERROR_078')) return false;

      let contextPropertyId = Number(item?.EntityPk || 0);
      if (item?.ContextJson) {
        try {
          const contextObj = typeof item.ContextJson === 'string'
            ? JSON.parse(item.ContextJson)
            : item.ContextJson;
          contextPropertyId = Number(contextObj?.property_id || 0);
        } catch (e) {
          // fall back to EntityPk when ContextJson is malformed
        }
      }
      return currentPropertyId > 0 && contextPropertyId === currentPropertyId;
    }).length;
    return matchingErrorCodeCount > 1;
  }, [propertyNibrsErrorArr, DecPropID]);

  return (
    <>
      {!isNibrsOnePage && <PropListng {...{ ListData }} />}
      <div className="col-12">
        <div className='row px-2'>
          <label htmlFor="" className='label-name ' style={{ fontSize: "15px" }}>Please Select the Offense Associate with this Property</label>
        </div>

        {ListData[0]?.PropertyType_Description === "Drug" ? <div className="alert alert-danger py-1 px-2 mb-1" style={{ maxWidth: 'max-content' }}>
          <span className="text-danger"> <strong>Note:</strong> When the Property Type = Drug, only Offense 35A = Drug/Narcotic Violation can be selected.</span>
        </div> : <div className="alert alert-danger py-1 px-2 mb-1" style={{ maxWidth: 'max-content' }}>
          <span className="text-danger"> <strong>Note:</strong>  Attempted, Completed, and Unfounded offenses cannot be selected together. To choose a different type, first deselect the current selection.</span>
        </div>}
        {shouldShowPropertyLossCodeError && (
          <div className="alert alert-danger py-1 px-2 mb-1" style={{ maxWidth: 'max-content' }}>
            <span className="text-danger">⚠️  <strong>Error:</strong>{' Selected Associated offenses have conflicting Property Loss code and cannot be used together for the same property.'}</span>
          </div>
        )}
        <div className="col-12 mt-2 mb-3">
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <DataTable
              columns={columns}
              data={effectiveScreenPermission ? effectiveScreenPermission[0]?.DisplayOK ? sortedAllOffenses : [] : sortedAllOffenses}
              noDataComponent={effectiveScreenPermission ? effectiveScreenPermission[0]?.DisplayOK ? "No offenses available" : "You don't have permission to view data" : 'No offenses available'}
              dense
              highlightOnHover
              fixedHeader
              persistTableHead={true}
              customStyles={{
                ...tableCustomStyles,
                tableWrapper: {
                  style: {
                    maxHeight: '300px',
                  },
                },
              }}
              conditionalRowStyles={conditionalRowStyles}
              fixedHeaderScrollHeight='300px'
            />
          </div>
        </div>
      </div>
      {errorTooltip.visible && (
        <div
          style={{
            position: 'fixed',
            left: `${errorTooltip.x}px`,
            top: `${errorTooltip.y - 12}px`,
            transform: 'translate(-50%, -100%)',
            zIndex: 99999,
            maxWidth: '560px',
            pointerEvents: 'none'
          }}
        >
          <div
            style={{
              background: '#ffecec',
              border: '2px solid #f44336',
              borderRadius: '6px',
              padding: '8px 12px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              color: '#f44336',
              fontSize: '14px',
              lineHeight: '20px',
              whiteSpace: 'normal',
              wordBreak: 'break-word'
            }}
          >
            <span style={{ display: 'block' }}>⚠️ {errorTooltip.text}</span>
          </div>
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '10px solid transparent',
              borderRight: '10px solid transparent',
              borderTop: '12px solid #f44336'
            }}
          ></div>
        </div>
      )}
    </>
  )
}

export default Offense